export default __webpack_public_path__ + "static/fonts/InclusiveSans-Bold_7Y4T_s.ttf";